import { ButtonGroup, Flex, FormControl, SimpleGrid } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Card from "../../../components/card/Card";
import CustomButton from "../../../components/Common/CustomButton";
import CustomInput from "../../../components/Common/CustomInput";
import CustomSelect from "../../../components/Common/CustomInput/CustomSelect";
import IsLoading from "../../../components/Common/IsLoading";
import { StatusData } from "../Category/Create";
import { selectAllGroupList } from "../group/redux/selector";
import { actions as groupActions } from "../group/redux/slice";
import { actions as subCategoryActions } from "../sub-category/redux/slice";

import MultiFileUpload from "../../../components/Common/CustomUpload/MultiFileUpload";
import {
  selectButtonLoading,
  selectFormData,
  selectLoading,
} from "./redux/selector";
import { actions } from "./redux/slice";
import { ProductType } from "./types";
import SingleFileUpload from "../../../components/Common/CustomUpload";

const Create = () => {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const form = useSelector(selectFormData);
  const groups = useSelector(selectAllGroupList);
  const loader = useSelector(selectLoading);
  const loading = useSelector(selectButtonLoading);

  React.useEffect(() => {
    dispatch(groupActions.doGetAllGroupList());
    dispatch(subCategoryActions.doGetAllSubCategoryList());
    return () => {};
  }, []);
  React.useEffect(() => {
    if (params.id) {
      dispatch(actions.doGetById(params?.id));
    }
    return () => {};
  }, [params.id]);

  const handleFieldChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.target;
    // if (name == "code") {
    //   const newValue = codeRegex.test(value);
    //   if (newValue) {
    //     dispatch(actions.updateFormValue({ key: name, value: value }));
    //   } else {
    //     toast.error("please enter valid code");
    //     return;
    //   }
    // }
    dispatch(actions.updateFormValue({ key: name, value: value }));
  };
  const handleUploadImage = (value: any) => {
    dispatch(actions.updateFormValue({ key: "featuredImage", value: value }));
  };
  const handleChangeUploadField = (name: string, val: any) => {
    dispatch(actions.updateImagesFormValue({ name: name, value: val }));
  };

  const handleDeleteFile = (name: string, index: number) => {
    dispatch(actions.doRemoveImages({ name: name, index: index }));
  };
  const handleCancel = () => {
    dispatch(actions.clearFrom());
    navigate(-1);
  };

  const handleSubmit = () => {
    if (form?._id) {
      dispatch(
        actions.doUpdate({
          callback() {
            dispatch(actions.clearFrom());
            navigate(-1);
          },
        })
      );
    } else {
      dispatch(
        actions.doCreate({
          callback() {
            dispatch(actions.clearFrom());
            navigate(-1);
          },
        })
      );
    }
  };

  useEffect(() => {
    console.log("groups", groups);

    return () => {};
  }, []);

  return (
    <Flex pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Card>
        {loader ? (
          <IsLoading />
        ) : (
          <FormControl>
            <SimpleGrid columns={[1, 1, 2, 3]} spacingX={5}>
              <CustomInput
                name={"title"}
                value={form?.title}
                handleChange={handleFieldChange}
                placeholder={`${t("common.form.enterTitle")}`}
                title={`${t("common.form.title")}`}
              />

              <CustomSelect
                name={"groupId"}
                value={form?.groupId}
                handleChange={handleFieldChange}
                title={`${t("product.form.groups")}`}
                data={groups.map((ele) => ({
                  _id: ele._id,
                  title: `${ele.title} - ${ele.packageTitle}`,
                }))}
                isFromApi
              />

              <CustomSelect
                name={"status"}
                value={form?.status}
                handleChange={handleFieldChange}
                title={`${t("common.form.status")}`}
                data={StatusData}
              />
            </SimpleGrid>
            <SimpleGrid columns={[1, 1, 2, 3, 4]} spacingX={5}>
              <SingleFileUpload
                file={form?.featuredImage}
                title={t("common.form.featuredImage")}
                handleUploadImage={(val: any) => {
                  handleUploadImage(val);
                }}
              />

              <MultiFileUpload
                data={form?.allergicImages}
                handleDeleteFile={(index) => {
                  handleDeleteFile("allergicImages", index);
                }}
                handleUploadImage={(val: any) => {
                  handleChangeUploadField("allergicImages", val);
                }}
                title={`${t("common.form.allergicFile")}`}
              />
            </SimpleGrid>

            <SimpleGrid columns={1} spacing={10}>
              <Flex flexDirection="column">
                <ButtonGroup justifyContent={"flex-end"} mt={8}>
                  <CustomButton
                    handleClick={handleCancel}
                    title={t("common.button.cancel")}
                    loading={false}
                    variant="light"
                    sx={{ marginRight: "20px" }}
                  />
                  <CustomButton
                    handleClick={handleSubmit}
                    title={t("common.button.save")}
                    loading={loading}
                    disabled={!form?.title}
                    sx={{ marginLeft: "20px" }}
                  />
                </ButtonGroup>
              </Flex>
            </SimpleGrid>
          </FormControl>
        )}
      </Card>
    </Flex>
  );
};

export default Create;
export const TypeData = [
  { _id: ProductType.SINGLE, value: "product.form.individualItem" },
  { _id: ProductType.PACKAGE, value: "product.form.packageItem" },
];
